import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Checkbox from '../../atoms/Checkbox';
import Chip from '../../atoms/Chip';
import Icon from '../../atoms/Icon';
import Text from '../../atoms/Text';
import IconDropDown from '../IconDropDown';

import styles from './TableCell.module.scss';
import usePresenter from './TableCell.presenter';
import getProps from './TableCell.props';
import { TableCellCombinedProps } from './types';

// MANUAL OVERRIDE - converted to forwardRef Component
const TableCell = React.forwardRef<HTMLDivElement, TableCellCombinedProps>((props, ref) => {
  const {
    type,
    state,
    size,
    className,
    classes,
    button,
    checkbox,
    chip,
    text,
    iconDropDown,
    icon,
    ...otherProps // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = `${type}${state}${size}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`tableCell${variantName}`];

  let componentView;

  switch (variantName) {
    case 'ButtonDefaultFullWidth': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button} />
        </div>
      );
      break;
    }
    case 'CheckboxDefaultXS': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Checkbox
            className={cx(styles.checkbox, classes?.checkbox)}
            {...internalProps.checkbox}
            {...checkbox} />
        </div>
      );
      break;
    }
    case 'ChipDefaultS': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Chip
            className={cx(styles.chip, classes?.chip)}
            {...internalProps.chip}
            {...chip} />
        </div>
      );
      break;
    }
    case 'TextPaddedDefaultL':
    case 'TextPaddedDefaultM':
    case 'TextDefaultL':
    case 'TextDefaultM':
    case 'HeadingDefaultFullWidth':
    case 'TextDefaultFullWidth': {
      componentView = (
        <div
          className={cx(currentStyle, className)}
          ref={ref} // MANUAL OVERRIDE
          {...otherProps} // MANUAL OVERRIDE
        >
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text} />
        </div>
      );
      break;
    }
    case 'IconDropDownDefaultFullWidth': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <IconDropDown
            className={cx(styles.iconDropDown, classes?.iconDropDown)}
            {...internalProps.iconDropDown}
            {...iconDropDown} />
        </div>
      );
      break;
    }
    case 'IconTextActivatedM':
    case 'IconTextDestructiveM':
    case 'IconTextPendingM': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.content, classes?.content)}>
            <Icon
              className={cx(styles.icon, classes?.icon)}
              {...internalProps.icon}
              {...icon} />
            <Text
              className={cx(styles.text, classes?.text)}
              {...internalProps.text}
              {...text} />
          </div>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
}); // MANUAL OVERRIDE

export default TableCell;
